/** Alinhado ao enum numérico da API: 0=Monthly, 1=Yearly */
export enum BillingInterval {
  Monthly = 0,
  Yearly = 1,
}

/** Status retornado como string pela API (SubscriptionDto.Status) */
export enum SubscriptionStatus {
  Pending = 'Pending',
  Active = 'Active',
  Suspended = 'Suspended',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
}

export const BILLING_INTERVAL_LABELS: Record<BillingInterval, string> = {
  [BillingInterval.Monthly]: 'Mensal',
  [BillingInterval.Yearly]: 'Anual',
};

export const SUBSCRIPTION_STATUS_LABELS: Record<SubscriptionStatus, string> = {
  [SubscriptionStatus.Pending]: 'Pendente',
  [SubscriptionStatus.Active]: 'Ativa',
  [SubscriptionStatus.Suspended]: 'Suspensa',
  [SubscriptionStatus.Cancelled]: 'Cancelada',
  [SubscriptionStatus.Expired]: 'Expirada',
};
